import React, {useCallback, useState} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import Toast from "../../../components/toast";
import {IResponseUserTO, userCreateValidationSchema} from "../../../models/user";
import {UserService} from "../../../services/user-service";
import {useFormik} from "formik";
import {DivForm, TextFieldLogin} from "../../auth/login/styles";
import {ButtonCancel, ButtonCreate, DivButton, DivFormInputs, DivTitle} from "../create/style";
import FormCreate from "../../../components/form-create";
import {BsFillPersonVcardFill, BsPersonLock} from "react-icons/bs";
import PageContainer from "../../../components/page-container";

export default function UpdateUser() {

  const location = useLocation();
  const navigate = useNavigate();

  const [data] = useState<IResponseUserTO>(location.state);
  const [loading, setLoading] = useState(false);
  const validateForm = () => {
    form.validateForm(form.values).then(errors => {
      Object.entries(errors).map((error) => Toast.error(error[1]));
    });
  };

  const handleUpdate = useCallback(
    async (user: IResponseUserTO) => {
      const result = await UserService.updateUser(user);
      if (typeof result === "object") {
        Toast.success("Usuário atualizado com sucesso!");
      }
    }, []
  );

  const form = useFormik({
    initialValues: {
      id: data.id,
      status: data.status,
      name: data.name,
      username: data.username,
      email: data.email,
    },
    validationSchema: userCreateValidationSchema,
    onSubmit: (values: IResponseUserTO) => {
      handleUpdate(values).then(() => {
        setLoading(false);
        navigate("/usuarios/listar");
      });
      setLoading(true);
    },
    validateOnChange: false,
  });
  return (
    <PageContainer>
      <DivForm onSubmit={form.handleSubmit}>
        <DivTitle>
          <h2>Atualizar Usuário</h2>
        </DivTitle>
        <DivFormInputs>
          <FormCreate title="Informações Pessoais" icon={<BsFillPersonVcardFill fontSize={25}/>}>
            <TextFieldLogin
              fullWidth
              label="Nome"
              name={"name"}
              id={"name"}
              variant="standard"
              value={form.values.name}
              onChange={form.handleChange}
            />
            <TextFieldLogin
              fullWidth
              label="Email"
              name={"email"}
              id={"email"}
              variant="standard"
              value={form.values.email}
              onChange={form.handleChange}
            />
          </FormCreate>
          <FormCreate title="Informações de login" icon={<BsPersonLock fontSize={25}/>}>
            <TextFieldLogin
              fullWidth
              label="Usuário"
              name={"username"}
              id={"username"}
              variant="standard"
              value={form.values.username}
              onChange={form.handleChange}
            />
          </FormCreate>
        </DivFormInputs>
        <DivButton>
          <ButtonCancel type={"button"} onClick={() => navigate("/usuarios/listar")}>Cancelar</ButtonCancel>
          <ButtonCreate type={"submit"} onClick={validateForm} disabled={loading}>Salvar</ButtonCreate>
        </DivButton>
      </DivForm>
    </PageContainer>
  );
}
